import { SEARCH_TRACKER_TRANSPORT_KEYWORD_LIST_ID } from "app/action_types/searchTracker_action_types";

export const searchTrackerTransportKeywordListId = (keywordListId: string) => {
    return {
        type: SEARCH_TRACKER_TRANSPORT_KEYWORD_LIST_ID,
        keywordListId,
    };
};
